import { useState, useEffect } from 'react';

const useResponsiveChart = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setWindowWidth(window.innerWidth), 150);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  const chartHeight = isMobile ? 300 : isTablet ? 400 : 500;
  const chartHeightSmall = isMobile ? 250 : isTablet ? 350 : 400;
  const chartHeightLarge = isMobile ? 320 : isTablet ? 420 : 550;

  const chartMargin = isMobile
    ? { top: 10, right: 15, left: 15, bottom: 60 }
    : isTablet
      ? { top: 15, right: 25, left: 25, bottom: 70 }
      : { top: 20, right: 40, left: 40, bottom: 80 };

  const chartMarginCompact = isMobile
    ? { top: 10, right: 10, left: 10, bottom: 40 }
    : isTablet
      ? { top: 15, right: 20, left: 20, bottom: 50 }
      : { top: 20, right: 30, left: 20, bottom: 60 };

  const axisLabelFontSize = isMobile ? '11px' : '13px';
  const tickFontSize = isMobile ? 10 : 12;

  return {
    chartHeight,
    chartHeightSmall,
    chartHeightLarge,
    chartMargin,
    chartMarginCompact,
    axisLabelFontSize,
    tickFontSize,
    isMobile,
    isTablet
  };
};

export default useResponsiveChart;
